<template>

  <v-dialog max-width="1250" v-model="dialog">
    <v-card>
      <v-card-title>
        <h4>{{ getTitle }}</h4>
        <v-spacer/>
        <v-icon @click="handleCancel">close</v-icon>
      </v-card-title>

      <v-card-text class="mt-8">
        <cu-huisarts-form :huisArts="huisArts"
                          @submit="handleSubmit"
                          @cancel="handleCancel"/>
      </v-card-text>

    </v-card>
  </v-dialog>

</template>

<script>
import {HuisArts} from "@/modules/huisarts/domains";
import CuHuisartsForm from "@/modules/huisarts/forms/CuHuisarts.vue";

export default {
  name: "cuHuisarts",
  components: {CuHuisartsForm},
  props: {
    huisArts: HuisArts | null,
    value: false
  },
  data() {
    return {
      dialog: this.value
    }
  },
  computed: {
    getTitle() {
      return Boolean(this.huisArts) ? this.$t('doctors.details.title') : this.$t('doctors.new.title');
    }
  },
  methods: {
    handleSubmit: function () {
      this.$emit('submit')
    },
    handleCancel: function () {
      this.$emit('input', false)
    }
  },
  watch: {
    value: function () {
      this.dialog = this.value;
    },
    dialog: function () {
      if (!this.dialog) {
        this.handleCancel();
      }
    }
  }
}
</script>

<style scoped>

</style>